import { render } from "./PdfSlides.vue?vue&type=template&id=107e9c1c&scoped=true"
import script from "./PdfSlides.vue?vue&type=script&lang=js"
export * from "./PdfSlides.vue?vue&type=script&lang=js"

import "./PdfSlides.vue?vue&type=style&index=0&id=107e9c1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107e9c1c"]])

export default __exports__